import { apiClient } from 'container/apiClient';
import { ReportApi } from 'api/ReportApi';

export const reportApi = new ReportApi(apiClient);
